var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert(".elipsis[data-v-fc8c75b0] {\n  white-space: nowrap;\n  width: 0px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}")
;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _sweetalert = require("sweetalert2");

var _sweetalert2 = _interopRequireDefault(_sweetalert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "AgentDashboard",
  props: ["country_code"],
  data: function data() {
    return {
      current_user: null,
      current_agent_slug: null,
      current_user_id: null,
      revenues: null,
      banner: null,
      revenue_data: null,
      customers_data: null,
      revenue_today: null,
      revenue_this_month: null,
      revenue_this_year: null,
      revenue_all_time: null,
      revenue_graph_data: null,
      customers_today: null,
      customers_total: null,
      avg_spending: null,
      avg_services: null,
      topup_amount: null,
      topup_phone: null,
      current_merchant: null,
      merchant_id: null,
      bank_accounts: [],
      selectedAccount: null,
      withdrawTo: null,
      mpesaAccount: null,
      consumer_secret: null,
      consumer_key: null,
      api_token: null,
      customers_url: null,
      withdrawal_amount: null,
      account_id: null,
      agent_current_account_id: null,
      float_account_id: null,
      current_account_balance: null,
      current_account_currency: null,
      float_account_currency: null,
      float_account_balance: null,
      popular_services: null,
      syncbal: 0,
      placeholder: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.consumer_secret = this.$attrs["con_secret"];
    this.consumer_key = this.$attrs["con_key"];
    this.merchant_id = this.merchant_id;
    this.getOauthToken();

    $("#depositModal").on("hidden.bs.modal", function () {
      _this.topup_amount = null;
    });
    $("#withdrawalModal").on("hidden.bs.modal", function () {
      _this.withdrawal_amount = null;
    });
    this.get_revenues();
    this.get_customer_stats();
    switch (this.country_code) {
      case "KE":
        this.placeholder = "2547XXXXXXXX";
        break;
      case "ML":
        this.placeholder = "2237XXXXXXXX";
        break;
      case "SL":
        this.placeholder = "2327XXXXXXXX";
        break;
      case "SS":
        this.placeholder = "2119XXXXXXXX";
        break;
      default:
        this.placeholder = "2547XXXXXXXX";
    }
  },
  created: function created() {
    this.banner = this.$attrs["banner"];
    this.current_user = this.$attrs["current_user"];
    this.current_agent_slug = this.$attrs["current_agent"];
    this.current_user_id = this.$attrs["current_user_id"];
    this.current_merchant = this.$attrs["current_merchant"];
    this.merchant_id = this.$attrs["merchant_id"];
    this.float_account_id = this.$attrs["float_account_id"];
    this.agent_current_account_id = this.$attrs["agent_current_account_id"];
    this.current_account_currency = this.$attrs["current_account_currency"];
    this.float_account_currency = this.$attrs["float_account_currency"];
    this.customers_url = this.current_merchant + "/customers";
  },


  methods: {
    trunc: function trunc(value) {
      var line = value;
      if (line.length > 10) {
        return line.substring(0, 10) + "...";
      }
      return value;
    },
    validateR: function validateR() {
      if (this.topup_phone == null || this.topup_phone.length < 10) {
        _sweetalert2.default.fire({
          icon: "error",
          title: "Oops...",
          text: "Please enter a valid phone number"
        });
        return;
      }

      var re = /^(254)\d{9}$/;
      if (!re.test(this.topup_phone)) {
        _sweetalert2.default.fire({
          icon: "error",
          title: "Oops...",
          text: "Please enter a valid Phone Number"
        });
        return;
      }

      if (this.topup_amount == null) {
        _sweetalert2.default.fire({
          icon: "error",
          title: "Oops...",
          text: "Please enter an amount !"
        });
        return;
      }

      if (this.topup_amount <= 0) {
        _sweetalert2.default.fire({
          icon: "error",
          title: "Oops...",
          text: "Please enter an amount greater than 0"
        });
        return;
      }

      location.href = "/" + this.current_merchant + "/" + this.current_agent_slug + "/topup/checkout/page?phone=" + this.topup_phone + "&amount=" + this.topup_amount + "&account=" + this.float_account_id;
    },
    getOauthToken: function getOauthToken() {
      var _this2 = this;

      var url = "/api/oauth/generate/token";
      var payload = {
        secret: this.consumer_secret,
        key: this.consumer_key
      };
      Vue.axios.post(url, payload).then(function (response) {
        _this2.api_token = response.data.token;
        _this2.loadBankAccounts();
      }).catch(function (error) {}).then(function () {});
    },
    loadBankAccounts: function loadBankAccounts() {
      var _this3 = this;

      var url = "/api/banks/accounts/filtered?merchant_ids=[" + this.merchant_id + "]";
      var api_headers = { Authorization: "Bearer " + this.api_token };
      Vue.axios.get(url, {
        headers: api_headers
      }).then(function (response) {
        _this3.bank_accounts = response.data.bank_accounts;
      }).catch(function (error) {}).then(function () {});
    },
    get_customer_stats: function get_customer_stats() {
      var _this4 = this;

      var url = "/api/dashboard/stats/customers";
      Vue.axios.get(url, {
        params: { owner_id: this.merchant_id, user_id: this.current_user_id }
      }).then(function (response) {
        _this4.customers_today = _this4.to_human_no_fixed(response.data.customers_today);
        _this4.customers_total = _this4.to_human_no_fixed(response.data.customers_total);
        _this4.avg_spending = _this4.to_human(response.data.avg_spending);
        _this4.avg_services = _this4.to_human_no_fixed(response.data.avg_services);
        _this4.popular_services = response.data.popular_services;
      }).catch(function (error) {}).then(function () {});
    },
    get_revenues: function get_revenues() {
      var _this5 = this;

      var url = "/api/dashboard/stats/revenues";
      Vue.axios.get(url, {
        params: {
          owner_id: this.merchant_id,
          user_id: this.current_user_id,
          agent_current_account_id: this.agent_current_account_id,
          float_account_id: this.float_account_id
        }
      }).then(function (response) {
        _this5.revenues = response.data;
        _this5.revenue_graph_data = _this5.revenues.revenue_graph_data;
        _this5.revenue_today = _this5.to_human(_this5.revenues.revenue_today.revenue.default_currency);
        _this5.revenue_this_month = _this5.to_human(_this5.revenues.revenue_this_month.revenue.default_currency);
        _this5.revenue_this_year = _this5.to_human(_this5.revenues.revenue_this_year.revenue.default_currency);
        _this5.revenue_data = _this5.revenues.revenue_data;
        _this5.revenue_all_time = _this5.to_human(_this5.revenues.revenue_all_time.revenue.default_currency);
        _this5.customers_data = _this5.revenues.customers_data;
        _this5.current_account_balance = _this5.to_human(_this5.revenues.current_balance);

        _this5.float_account_balance = _this5.to_human(_this5.revenues.float_balance);
        _this5.$emit("syncbal", _this5.revenues.current_balance);
      }).catch(function (error) {}).then(function () {});
    },
    to_human_no_fixed: function to_human_no_fixed(x) {
      if (x == null) return 0;
      return x.toLocaleString();
    },
    to_human: function to_human(x) {
      var n = this.to_fixed(x);
      return n.toLocaleString();
    },
    to_fixed: function to_fixed(val) {
      return (Math.round(val * 100) / 100).toFixed(2);
    },
    generate_req_ref: function generate_req_ref() {
      var length = 6;
      var result = "";
      var characters = "ABCDEFGHIJKLMNPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz123456789";
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }
      return result.toUpperCase();
    },
    validateWithdrawal: function validateWithdrawal() {
      var re = /^(25471|25470|25472|25479|25474)\d{7}$/;
      if (!re.test(this.mpesaAccount)) {
        _sweetalert2.default.fire({
          icon: "error",
          title: "Oops...",
          text: "Please enter a valid Safaricom Phone Number"
        });
        return;
      }

      if (this.withdrawal_amount == null) {
        _sweetalert2.default.fire({
          icon: "error",
          title: "Oops...",
          text: "Please enter an amount!"
        });
        return false;
      }
      if (parseFloat(this.withdrawal_amount) <= 0) {
        _sweetalert2.default.fire({
          icon: "error",
          title: "Oops...",
          text: "Please enter an amount not less than 1 !"
        });
        return false;
      }

      if (parseFloat(this.withdrawal_amount) > parseFloat(this.current_account_balance)) {
        _sweetalert2.default.fire({
          icon: "error",
          title: "Oops...",
          text: "Please enter an amount not greater than " + this.current_account_balance
        });
        return false;
      }

      if (this.selectedAccount == null && this.mpesaAccount == null) {
        _sweetalert2.default.fire({
          icon: "error",
          title: "Oops...",
          text: "Please select either a bank account or mobile money account !"
        });
        return false;
      }

      this.executeWithdrawal();
    },
    resetWithdrawalForm: function resetWithdrawalForm() {
      this.selectedAccount = null;
      this.mpesaAccount = null;
      this.withdrawal_amount = null;
      this.withdrawTo = null;
    },
    executeWithdrawal: function executeWithdrawal() {
      var _this6 = this;

      var bankAccountId = null;
      var gateway = "mpesa-b2c";
      if (this.selectedAccount != null) {
        bankAccountId = this.selectedAccount.id;
        gateway = "mpesa";
      }
      var params = {
        bank_account_id: bankAccountId,
        destination: this.mpesaAccount,
        amount: this.withdrawal_amount,
        account_id: this.agent_current_account_id,
        gateway: gateway
      };

      this.resetWithdrawalForm();
      _sweetalert2.default.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, withdraw funds"
      }).then(function (result) {
        if (result.value) {
          _this6.authorizeWithdrawal(params);
        }
      });
    },
    authorizeWithdrawal: function authorizeWithdrawal(params) {
      var _this7 = this;

      var url = "/api/oauth/generate/token";
      var payload = {
        secret: this.consumer_secret,
        key: this.consumer_key
      };
      Vue.axios.post(url, payload).then(function (response) {
        _this7.api_token = response.data.token;
        _this7._make_withdrawal(_this7.api_token, params);
      }).catch(function (error) {}).then(function () {});
    },
    _make_withdrawal: function _make_withdrawal(token, params) {
      var urlIs = "/api/payment/withdraw";
      var api_headers = {
        Authorization: "Bearer " + token
      };
      Vue.axios.post(urlIs, params, {
        headers: api_headers
      }).then(function (response) {
        if (response.data.status == 422) {
          _sweetalert2.default.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!"
          });
        } else {
          $("#withdrawalModal .close").click();
          _sweetalert2.default.fire({
            position: "top-end",
            icon: "success",
            title: "Withdrawal Inititated !",
            showConfirmButton: false,
            timer: 2500
          });
        }
      }).catch(function (error) {
        _sweetalert2.default.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!"
        });
      }).then(function () {});
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"card mt-4",staticStyle:{"background":"#fffef8"}},[_c('div',{staticClass:"card-body py-2"},[_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col-12 col-lg-4 order-lg-2"},[_c('div',{staticClass:"text-center"},[_c('img',{staticClass:"img-fluid mt-md-n5 mt-lg-0 mr-md-n5",staticStyle:{"max-width":"397px"},attrs:{"src":_vm.banner,"alt":"..."}})])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-8 px-4 py-3 order-lg-1"},[_c('span',{staticClass:"h2 mb-0"},[_vm._v("Welcome back, Agent "+_vm._s(_vm.current_user))]),_vm._v(" "),(_vm.revenue_today > 0)?_c('p',{staticClass:"mt-2 text-muted"},[_vm._v("\n            Here’s how the numbers are looking. You have earned "+_vm._s(_vm.current_account_currency)+".\n            "+_vm._s(_vm.revenue_today)+" today. Keep it up\n          ")]):_vm._e(),_vm._v(" "),(_vm.revenue_today <= 0)?_c('p',{staticClass:"mt-2 text-muted"},[_vm._v("\n            Here’s how the numbers are looking. You have earned "+_vm._s(_vm.current_account_currency)+".\n            "+_vm._s(_vm.revenue_today)+" today.\n          ")]):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-auto align-middle"},[_c('span',{staticClass:"h1"},[_vm._v(_vm._s(_vm.current_account_currency)+". "+_vm._s(_vm.current_account_balance))])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-auto"},[(_vm.current_account_balance > 0)?_c('a',{staticClass:"mt-3 mt-md-0 btn btn-sm btn-outline-primary btn-block lift",attrs:{"href":"#","data-toggle":"modal","data-target":"#withdrawalModal"}},[_vm._v("Withdraw")]):_vm._e()]),_vm._v(" "),(_vm.float_account_id)?_c('div',{staticClass:"col-12 col-md-auto"},[_c('a',{staticClass:"mt-3 mt-md-0 btn btn-sm btn-outline-primary btn-block lift",attrs:{"href":"#","data-toggle":"modal","data-target":"#depositModal"}},[_vm._v("Deposit float")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-auto align-middle"},[_c('span',{staticClass:"h1"},[_vm._v(_vm._s(_vm.float_account_currency)+". "+_vm._s(_vm.float_account_balance))])])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-lg-6 col-xl"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col"},[_c('h6',{staticClass:"text-uppercase text-muted mb-2"},[_vm._v("Today")]),_vm._v(" "),_c('span',{staticClass:"h2 mb-0"},[_vm._v(_vm._s(_vm.current_account_currency)+". "+_vm._s(_vm.revenue_data.today.total_balance))])]),_vm._v(" "),_vm._m(0)])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-6 col-xl"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col"},[_c('h6',{staticClass:"text-uppercase text-muted mb-2"},[_vm._v("This month")]),_vm._v(" "),_c('span',{staticClass:"h2 mb-0"},[_vm._v(_vm._s(_vm.current_account_currency)+". "+_vm._s(_vm.revenue_data.this_month.total_balance))])]),_vm._v(" "),_vm._m(1)])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-6 col-xl"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col"},[_c('h6',{staticClass:"text-uppercase text-muted mb-2"},[_vm._v("This year")]),_vm._v(" "),_c('span',{staticClass:"h2 mb-0"},[_vm._v(_vm._s(_vm.current_account_currency)+"."+_vm._s(_vm.revenue_data.this_year.total_balance))])]),_vm._v(" "),_c('div',{staticClass:"col-auto"})])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-6 col-xl"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col"},[_c('h6',{staticClass:"text-uppercase text-muted mb-2"},[_vm._v("All time revenue")]),_vm._v(" "),_c('span',{staticClass:"h2 mb-0"},[_vm._v(_vm._s(_vm.current_account_currency)+". "+_vm._s(_vm.revenue_data.all_time.total_balance))])]),_vm._v(" "),_vm._m(2)])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-xl-12"},[_c('div',{staticClass:"card"},[_vm._m(3),_vm._v(" "),(_vm.revenue_graph_data != null)?_c('div',{staticClass:"card-body",staticStyle:{"height":"100%","width":"100%"}},[_c('agent-revenue-30day-chart',{attrs:{"merchant_id":_vm.merchant_id,"user_id":_vm.current_user_id,"revenue_graph_data":_vm.revenue_graph_data}})],1):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-lg-6 col-xl"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col"},[_c('h6',{staticClass:"text-uppercase text-muted mb-2"},[_vm._v("Customers Today")]),_vm._v(" "),_c('span',{staticClass:"h2 mb-0"},[_vm._v(_vm._s(_vm.customers_data.today.number_of_customers))])]),_vm._v(" "),_vm._m(4)])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-6 col-xl"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col"},[_c('h6',{staticClass:"text-uppercase text-muted mb-2"},[_vm._v("Customers This Month")]),_vm._v(" "),_c('span',{staticClass:"h2 mb-0"},[_vm._v(_vm._s(_vm.customers_data.this_month.number_of_customers))])]),_vm._v(" "),_vm._m(5)])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-6 col-xl"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col"},[_c('h6',{staticClass:"text-uppercase text-muted mb-2"},[_vm._v("Customers This Year")]),_vm._v(" "),_c('span',{staticClass:"h2 mb-0"},[_vm._v(_vm._s(_vm.customers_data.this_year.number_of_customers))])]),_vm._v(" "),_vm._m(6)])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-6 col-xl"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col"},[_c('h6',{staticClass:"text-uppercase text-muted mb-2"},[_vm._v("Customers All Time")]),_vm._v(" "),_c('span',{staticClass:"h2 mb-0"},[_vm._v(_vm._s(_vm.customers_data.all_time.number_of_customers))])]),_vm._v(" "),_vm._m(7)])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"card"},[_vm._m(8),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('agent-customer-30day-chart',{attrs:{"merchant_id":_vm.merchant_id,"user_id":_vm.current_user_id}})],1)])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-xl-4 d-none"},[_c('div',{staticClass:"card card-fill"},[_vm._m(9),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-sm table-nowrap card-table"},[_c('thead',[_c('tr',[_vm._m(10),_vm._v(" "),_vm._m(11),_vm._v(" "),_c('th',[_c('a',{staticClass:"text-muted sort",attrs:{"href":"#","data-sort":"customer-services"}},[_vm._v(_vm._s(_vm.float_account_currency))])])])]),_vm._v(" "),(_vm.popular_services)?_c('tbody',{staticClass:"list"},_vm._l((_vm.popular_services),function(item,i){return _c('tr',{key:i},[_c('td',{staticClass:"elipsis"},[_vm._v(_vm._s(_vm.trunc(item.service_name)))]),_vm._v(" "),_c('td',{staticClass:"customer-phone"},[_vm._v("\n                  "+_vm._s(_vm.to_human(item.customers_total))+"\n                ")]),_vm._v(" "),_c('td',{staticClass:"customer-services"},[_vm._v("\n                  "+_vm._s(_vm.to_human(item.agent_margin))+"\n                ")])])}),0):_vm._e()])])])])]),_vm._v(" "),_c('withdrawal-tool',{attrs:{"conkey":_vm.con_key,"consecret":_vm.con_secret,"merchantid":_vm.merchant_id,"syncbal":_vm.current_account_balance,"currentaccountbalance":_vm.current_account_balance},on:{"update:syncbal":function($event){_vm.current_account_balance=$event}}}),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"depositModal","tabindex":"-1","role":"dialog","aria-labelledby":"depositModal","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('form',{attrs:{"id":"frmDeposit","name":"frmDeposit","onsubmit":"return false;"}},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v("Deposit Funds "+_vm._s(_vm.current_merchant))]),_vm._v(" "),_vm._m(12)]),_vm._v(" "),_c('div',{staticClass:"modal-body",staticStyle:{"overflow":"auto"}},[_c('div',{staticClass:"md-form mb-5"},[_c('label',{attrs:{"data-error":"wrong","data-success":"right","for":"amount"}},[_vm._v("Phone Number")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.topup_phone),expression:"topup_phone"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.placeholder},domProps:{"value":(_vm.topup_phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.topup_phone=$event.target.value}}}),_vm._v(" "),_c('label',{attrs:{"data-error":"wrong","data-success":"right","for":"amount"}},[_vm._v("Amount")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.topup_amount),expression:"topup_amount"}],staticClass:"form-control",attrs:{"type":"number","min":"1","max":"70000","id":"ag_deposit_amount"},domProps:{"value":(_vm.topup_amount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.topup_amount=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v("\n              Close\n            ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-primary",attrs:{"href":"#","type":"button"},on:{"click":_vm.validateR}},[_vm._v("Checkout")])])])])])])],1)}
__vue__options__.staticRenderFns = [function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-auto"},[_c('span',{staticClass:"h2 fe fe-dollar-sign text-muted mb-0"})])},function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-auto"},[_c('span',{staticClass:"h2 fe fe-briefcase text-muted mb-0"})])},function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-auto"},[_c('span',{staticClass:"h2 fe fe-clock text-muted mb-0"})])},function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-header-title"},[_vm._v("Revenue")]),_vm._v(" "),_c('span',{staticClass:"text-muted mr-3 d-none"},[_vm._v("Last year comparison:")]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-switch d-none"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"cardToggle","data-toggle":"chart","data-target":"#conversionsChart","data-trigger":"change","data-action":"add","data-dataset":"1"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"cardToggle"}})])])},function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-auto"},[_c('span',{staticClass:"h2 fe fe-dollar-sign text-muted mb-0"})])},function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-auto"},[_c('span',{staticClass:"h2 fe fe-briefcase text-muted mb-0"})])},function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-auto"},[_c('div',{staticClass:"chart chart-sparkline"})])},function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-auto"},[_c('span',{staticClass:"h2 fe fe-clock text-muted mb-0"})])},function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-header-title"},[_vm._v("Customers")])])},function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-header-title"},[_vm._v("Popular Services")])])},function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',[_c('a',{staticClass:"text-muted sort",attrs:{"href":"#","data-sort":"customer-id"}},[_vm._v("Service")])])},function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',[_c('a',{staticClass:"text-muted sort",attrs:{"href":"#","data-sort":"customer-phone"}},[_vm._v("Applications")])])},function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])}]
__vue__options__._scopeId = "data-v-fc8c75b0"
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  module.hot.dispose(__vueify_style_dispose__)
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-fc8c75b0", __vue__options__)
  } else {
    hotAPI.reload("data-v-fc8c75b0", __vue__options__)
  }
})()}